import { render } from "./Footer.vue?vue&type=template&id=384239a4&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=384239a4&lang=scss&scoped=true"
import "./Footer.vue?vue&type=style&index=1&id=384239a4&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384239a4"]])

export default __exports__